import * as React from 'react'
import * as Reakit from 'reakit/Tooltip'

interface TooltipButtonProps extends Reakit.TooltipReferenceHTMLProps {
  state: Reakit.TooltipStateReturn

  /**
   * Whether or not should trigger element call blur to return focus back to body after click
   *
   * @default false
   */
  isBlurAfterClick?: boolean

  /**
   * Whether to ignore default mouse enter/leave tooltip trigger interactions
   * and hide tooltip only after clicking outside of the trigger element
   *
   * @default false
   */
  isHideOnClickOutside?: boolean
}
/**
 * The trigger button component which handles ref & focus return, etc.
 */
export const TooltipTrigger = React.forwardRef(
  (
    {
      state,
      isBlurAfterClick,
      isHideOnClickOutside,
      onClick,
      onMouseEnter,
      onMouseLeave,
      ...props
    }: TooltipButtonProps,
    ref: React.ForwardedRef<HTMLDivElement>
  ) => (
    <Reakit.TooltipReference
      ref={ref}
      onClick={(e) => {
        if (isBlurAfterClick && document.activeElement instanceof HTMLElement) {
          document.activeElement.blur()
        }
        onClick?.(e)
      }}
      onMouseEnter={(e) => {
        if (isHideOnClickOutside) e.preventDefault()
        onMouseEnter?.(e)
      }}
      onMouseLeave={(e) => {
        if (isHideOnClickOutside) e.preventDefault()
        onMouseLeave?.(e)
      }}
      {...props}
      {...state}
    >
      {props.children}
    </Reakit.TooltipReference>
  )
)
